import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = 'Invoicely AI';
  }, [pathname]);

  return null;
};

export default TitleManager;
